export const notifications = {
  successDataUpdate: 'Data updated successfully.',
  errorOnDataUpdate: 'An error occurred while updating the data.',
  waitResponseIn24Hours:
    'Expect a response to your invitation within 72 hours.',
  workItemIsCanceled: 'The invitation has been withdrawn.',
  notificationDeleted: 'The notification has been deleted.',
  noNotifications: 'You have no notifications.',
  workInviteRejected: 'Invitation declined.',
  workStartOnArtistArrivalConfirm:
    'Work will begin once the club confirms your presence at the workplace.',
  giveResponseFormWorkItem:
    'Please respond within 72 hours.',
  generalError: 'Something went wrong, please try again later.',
  passwordReseted: 'Password has been reset.',
  languageSwitched: 'Language updated.',
  invitationExpired: 'The invitation has expired.',
  linkIsCopied: 'Link copied to clipboard.',
  accountIsVisible: 'Your account will now appear in search.',
  hiringEnabled: 'Artist hiring is open.',
  hiringDisabled: 'Artist hiring is closed.',
  rejectedForReason: 'Rejected: {content}.',
  profileDeleted: 'Profile deleted.',
  accountHiddenFromSearch:
    'Your account is hidden and no longer appears in artist searches.',
  registerRequestSended: 'Registration request submitted.',
  notFoundNotifications: 'You have no notifications.',
  lastWorkDaySeted: 'Last working day set.'
};
